"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Main_1 = __importDefault(require("./Main"));
var MusicHeader_1 = __importDefault(require("./MusicHeader"));
function MusicPage(_a) {
    var children = _a.children, category = _a.category;
    return (react_1.default.createElement(Main_1.default, null,
        react_1.default.createElement("article", { className: "post", id: "index" },
            react_1.default.createElement("header", null,
                react_1.default.createElement("div", { className: "title" },
                    react_1.default.createElement("h2", null, "What I've been listening to"))),
            react_1.default.createElement(MusicHeader_1.default, { selected: category }),
            children)));
}
exports.default = MusicPage;
